// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__AnxPH6b8","wrapperContent":"wrapper-content__En6VgVW2"};